import type { ColorValue } from "common/constants/colorsOld";
import colors from "common/constants/colorsOld";
import type { ReactNode } from "react";
import styles from "./TextareaMaxCharWrapper.module.scss";

interface TextareaMaxCharWrapperProps {
  maxLength: number;
  charLength: number;
  children: ReactNode;
}

export default function TextareaMaxCharWrapper({ children, maxLength, charLength }: TextareaMaxCharWrapperProps) {
  const charIndicatorColor: ColorValue = maxLength === charLength ? colors.ruby : colors.stone;
  return (
    <div className={styles.charLimitWrapper}>
      {children}
      <label className={styles.charLimitLabel} style={{ color: charIndicatorColor }}>
        {charLength}/{maxLength}
      </label>
    </div>
  );
}
